import React, { useState, useEffect } from "react";
import { Card, Tabs, Button, Typography, Row, Col, message } from "antd";
import { useLocation, useParams, useHistory } from "react-router-dom";
import Page from "../../../components/page";
import Header from "./form/header";
import Entitas from "./form/entitas";
import Dokumen from "./form/dokumen";
import Pengangkut from "./form/pengangkut";
import Kemasan from "./form/kemasan";
import Transaksi from "./form/transaksi";
import Barang from "./form/barang";
import Pungutan from "./form/pungutan";
import Pernyataan from "./form/pernyataan";
import "./DokumenPabean.css";

const { TabPane } = Tabs;
const { Title } = Typography;

const DokumenPabean = () => {
    const { id } = useParams();
    const location = useLocation();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState("header");
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id === "new") {
            // Try to get params from location.search (standard)
            let searchParams = new URLSearchParams(location.search);
            let role = searchParams.get("role");
            let kodeDokumen = searchParams.get("kodeDokumen");

            // Fallback for HashRouter if params are in the hash
            if (!role || !kodeDokumen) {
                const hash = window.location.hash;
                if (hash.includes("?")) {
                    const query = hash.split("?")[1];
                    const params = new URLSearchParams(query);
                    role = params.get("role");
                    kodeDokumen = params.get("kodeDokumen");
                }
            }

            console.log("Parsed Params:", { role, kodeDokumen });

            if (role && kodeDokumen) {
                setData({
                    role: role,
                    kodeDokumen: kodeDokumen,
                    idHeader: null,
                    nomorAju: `0000${kodeDokumen}-123456-20251121-500173`,
                });
            } else {
                // Fallback for development/refresh
                console.warn("Params missing, using fallback data.");
                setData({
                    role: "PLB",
                    kodeDokumen: "16",
                    idHeader: null,
                    nomorAju: "000016-123456-20251121-500173",
                });
            }
        } else {
            // Fetch existing data logic here
            setLoading(true);
            setTimeout(() => {
                setData({ idHeader: id, role: "PLB", kodeDokumen: "16" });
                setLoading(false);
            }, 1000);
        }
    }, [id, location.search, history]);

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const onFinish = () => {
        message.success("Data berhasil disimpan!");
    };

    return (
        <Page loading={loading}>
            <div className="page-container">
                <Card
                    className="card-custom"
                    title={
                        <Row gutter={[16, 16]} align="middle">
                            <Col span={24}>
                                <Title level={4} style={{ marginTop: 10, fontSize: '1.1rem', fontWeight: 600, color: '#181C32', margin: 0, lineHeight: "1.4" }}>
                                    {data.kodeDokumen === "27"
                                        ? "BC 2.7 - PEMBERITAHUAN PENGELUARAN UNTUK DIANGKUT DARI TEMPAT PENIMBUNAN BERIKAT KE TEMPAT PENIMBUNAN BERIKAT LAINNYA"
                                        : "BC 1.6 - PEMBERITAHUAN PABEAN PENGELUARAN BARANG DARI KAWASAN PABEAN UNTUK DITIMBUN DI PUSAT LOGISTIK BERIKAT"}
                                </Title>
                            </Col>
                            <Col span={24} style={{ textAlign: "right" }}>
                                <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: "8px", justifyContent: 'flex-end' }}>
                                    <Button className="btn-light" onClick={() => history.push("/portal")}>
                                        Kembali
                                    </Button>
                                    <Button>Cetak</Button>
                                    <Button>Validasi</Button>
                                    <Button type="primary" onClick={onFinish}>
                                        Kirim
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    }
                >
                    <Tabs activeKey={activeTab} onChange={handleTabChange} type="line" className="custom-tabs">
                        <TabPane tab="Header" key="header">
                            <Header data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Entitas" key="entitas">
                            <Entitas data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Dokumen" key="dokumen">
                            <Dokumen data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Pengangkut" key="pengangkut">
                            <Pengangkut data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Kemasan & Peti Kemas" key="kemasan">
                            <Kemasan data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Transaksi" key="transaksi">
                            <Transaksi data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Barang" key="barang">
                            <Barang data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Pungutan" key="pungutan">
                            <Pungutan data={data} setData={setData} />
                        </TabPane>
                        <TabPane tab="Pernyataan" key="pernyataan">
                            <Pernyataan data={data} setData={setData} />
                        </TabPane>
                    </Tabs>

                    <Row justify="end" style={{ marginTop: 20 }}>
                        <Button type="primary" onClick={() => message.info("Next Step")}>
                            Selanjutnya
                        </Button>
                    </Row>
                </Card>
            </div>
        </Page>
    );
};

export default DokumenPabean;
